import { company } from '@/lib/company';
import '../website-legal.css';

export function WebsiteFooter() {
  return (
    <footer className="signup-container website-footer">
      <div className="website-company">
        <p>
          Asset Hound refers to {company.name}, a company incorporated in{' '}
          {company.jurisdiction} with{' '}
          <span className="website-company-number">
            company number <a href={company.registerUrl}>{company.number}</a>
          </span>
          .
        </p>
        <p>Registered office: {company.registeredOffice}.</p>
      </div>
      <nav aria-label="Legal information">
        <a href="/privacy">Privacy Policy</a>
        <a href="/terms">Terms &amp; Conditions</a>
        <a href="/cookies">Cookies</a>
      </nav>
    </footer>
  );
}
